var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/graphlib/~/lodash/_Symbol.js
// module id = 181
// module chunks = 0